$(window).on('load', function() {
    let window_width = $(window).width();
    if(window_width < 768) {
        $('.button.add-2-cart').each(function () {
            $(this).html('+')
        })
    }
}).trigger('resize')

$(window).on("resize", function () {
    if ($(window).width() <= 1100) {
        $('.nav-item').each(function () {
            if ($(this).hasClass('showChildren')) {
                let submenuHeight = $(this).find('ul.nav-secondary').height();
                let h = submenuHeight + 60;
                $(this).css("height", h);
                $(this).find('.toggler').css("transform", 'rotate(180deg)');
            } else {
                $(this).css("height", '');
            }
        })
    } else if ($(window).width() > 1100) {
        $('.nav-item').each(function () {
            $(this).css("height", '');
            $('.toggler').each(function () {
                $(this).css("transform", '');
            })
        })
    }
});

$(document).ready(function () {
    // Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length) {
        changeErrMsg();
    }
});

function changeErrMsg() {
    let targetParent = $('.nocaptcha')
    let target;

    if (targetParent.children('.message.error').length) {
        target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

// Navigation
$('#menu-toggle').on('click', function() {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$('.nav-item').on('click', function () {
    if ($(window).width() <= 1100) {
        let secondNav = $(this).children('.nav-secondary');
        let toggler = $(this).children('.nav-label').children('.toggler');

        if ($(this).hasClass('showChildren')) {
            $(this).removeClass('showChildren');
            $(this).animate({
                height: 60
            });

            toggler.animate({
                deg: 0
            }, {
                duration: 250,
                step: function (now) {
                    toggler.css({
                        transform: 'rotate(' + now + 'deg)'
                    });
                }
            });
        } else {

            $('.nav-item').each(function () {
                if ($(this).hasClass('showChildren')) {
                    ($(this).removeClass('showChildren'));
                    $(this).animate({
                        height: 60
                    });

                    let toggler = $(this).children('.nav-label').children('.toggler');
                    toggler.animate({
                        deg: 0
                    }, {
                        duration: 250,
                        step: function (now) {
                            toggler.css({
                                transform: 'rotate(' + now + 'deg)'
                            });
                        }
                    });
                }
            })

            $(this).addClass('showChildren');

            let menuHeight = secondNav.height();
            let h = menuHeight + 60;

            $(this).animate({
                height: h,
            });

            toggler.animate({
                    deg: 180
                },
                {
                    duration: 250,
                    step: function (now) {
                        toggler.css({
                            transform: 'rotate(' + now + 'deg)'
                        });
                    }
                });
        }
    }
});

$('.LISTVIEW ul').children('li').each(function () {
    // get value of child
    let liText = $(this);

    // append to a span somehow
    liText.wrapInner('<div class="li-text-container">');
    liText.children().wrapInner('<span class="li-text">');
});

/* Modal */
$('.add-details').on('click', function() {
    $(this).siblings('.participant-details').css('display', 'block');
    $('body').css('overflow', 'hidden');
});

$('.close').on('click', function() {
    $('.participant-details').css('display', 'none');
    $('body').css('overflow', 'unset');

});

$(window).on('click', function(event) {
    if ($('.participant-details').is(event.target)) {
        $('.participant-details').css('display', 'none');
        $('body').css('overflow', 'unset');
    }
});

$('label[for="CheckoutForm_PaymentMethodForm_PaymentMethod_PaymentExpress_PxPay"]').text('Credit Card')
$('label[for="CheckoutForm_PaymentMethodForm_PaymentMethod_Manual"]').text('Bank Transfer')


function initMap() {
    const center = { lat: -45.878148, lng: 170.4999759 };
    const defaultBounds = {
        north: center.lat + 0.1,
        south: center.lat - 0.1,
        east: center.lng + 0.1,
        west: center.lng - 0.1,
    };
    $('textarea[name=ParticipantAddress]').each(function () {
        var $ta = $(this),
            autocomplete = new google.maps.places.Autocomplete(
            this,
            {
                bounds: defaultBounds,
                types: ['geocode'],
            });
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            $ta.val(autocomplete.getPlace().formatted_address
                .replace(/,/g, "\n")
                .replace('New Zealand', '')
                .trim())
        });
    })

}
